import { trustItems } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center pt-16">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20toned%20editorial%20flatlay%20composition%20featuring%20colorful%20sneakers%20a%20dark%20grey%20hoodie%20a%20crisp%20white%20tee%20and%20a%20black%20cap%20on%20a%20rich%20walnut%20wooden%20surface%2C%20soft%20golden%20hour%20sunlight%20streaming%20diagonally%20across%20the%20scene%2C%20natural%20shadows%20depth%2C%20lifestyle%20product%20photography%20with%20warm%20amber%20and%20terracotta%20tones%2C%20sophisticated%20European%20aesthetic&width=1600&height=1000&seq=hero-bg-v02&orientation=landscape"
          alt="CSSBuy Spreadsheet produtos verificados"
          title="CSSBuy Spreadsheet - Produtos Verificados"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-background-50"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 lg:px-14 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 w-full max-w-[1400px] mx-auto">
          {/* Left Column - 35% */}
          <div className="w-full lg:w-[35%] flex flex-col justify-center">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
              Melhor CSSBuy Spreadsheet 2026 – Produtos Verificados e Links Atualizados
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 max-w-lg">
              Encontre os melhores produtos do CSSBuy Spreadsheet com links verificados, QC real e envio seguro para Brasil e Portugal.
            </p>

            <div className="flex flex-wrap gap-2 mb-8">
              {trustItems.map((item) => (
                <span
                  key={item.title}
                  className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50/80 rounded-full whitespace-nowrap"
                >
                  <i className={`${item.icon} text-xs`}></i>
                  {item.title}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold text-primary-600 border-2 border-primary-300 hover:border-primary-500 hover:bg-primary-50 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - 35% */}
          <div className="w-full lg:w-[35%]">
            <div className="relative rounded-3xl overflow-hidden h-[320px] md:h-[450px] lg:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vertical%20editorial%20collage%20of%20modern%20streetwear%20fashion%20items%20styled%20on%20a%20warm%20terracotta%20toned%20surface%2C%20a%20cream%20colored%20chunky%20sneaker%20overlapping%20a%20sage%20green%20hoodie%20and%20a%20white%20graphic%20tee%2C%20a%20tan%20suede%20cap%20resting%20on%20top%2C%20soft%20golden%20sunlight%20with%20gentle%20shadows%2C%20sophisticated%20European%20magazine%20editorial%20style&width=700&height=900&seq=hero-collage-v02&orientation=portrait"
                alt="CSSBuy Spreadsheet collage de produtos"
                title="Produtos CSSBuy Spreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column - 30% */}
          <div className="w-full lg:w-[30%] flex flex-col justify-center">
            <div className="flex items-center gap-2 mb-6">
              <h2 className="font-heading text-xl font-semibold text-foreground-900">
                Categorias em Destaque
              </h2>
              <i className="ri-arrow-right-line text-primary-500"></i>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <a
                href="https://kaspreadsheet.com/category-911-Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="relative rounded-2xl overflow-hidden h-40 cursor-pointer group"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20grey%20and%20white%20sneakers%20photographed%20from%20a%20low%20angle%20on%20a%20warm%20amber%20wooden%20floor%2C%20dramatic%20afternoon%20sunlight%20casting%20long%20shadows%2C%20editorial%20product%20photography%20with%20rich%20warm%20tones%20and%20urban%20streetstyle%20aesthetic&width=400&height=320&seq=hero-cat-shoes-v02&orientation=landscape"
                  alt="Shoes CSSBuy"
                  title="Shoes - CSSBuy Spreadsheet"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 text-sm font-semibold text-white bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                  Shoes
                </span>
              </a>

              <a
                href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="relative rounded-2xl overflow-hidden h-40 cursor-pointer group"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=A%20black%20oversized%20hoodie%20draped%20over%20a%20wooden%20chair%20back%20in%20a%20sunlit%20room%2C%20warm%20golden%20light%20filtering%20through%20nearby%20window%2C%20soft%20shadows%20on%20the%20wall%2C%20lifestyle%20editorial%20photography%20with%20cozy%20yet%20urban%20streetwear%20feel&width=400&height=320&seq=hero-cat-hoodies-v02&orientation=landscape"
                  alt="Hoodies CSSBuy"
                  title="Hoodies - CSSBuy Spreadsheet"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 text-sm font-semibold text-white bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                  Hoodies
                </span>
              </a>

              <a
                href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="relative rounded-2xl overflow-hidden h-40 cursor-pointer group"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=A%20crisp%20white%20t-shirt%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20warm%20sandy%20colored%20wall%2C%20soft%20natural%20light%20from%20the%20side%20creating%20gentle%20shadows%2C%20clean%20editorial%20product%20photography%20with%20Scandinavian%20simplicity%20and%20warm%20undertones&width=400&height=320&seq=hero-cat-tshirts-v02&orientation=landscape"
                  alt="T-Shirts CSSBuy"
                  title="T-Shirts - CSSBuy Spreadsheet"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 text-sm font-semibold text-white bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                  T-Shirts
                </span>
              </a>

              <a
                href="https://kaspreadsheet.com/search-914/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="relative rounded-2xl overflow-hidden h-40 cursor-pointer group"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=A%20camel%20colored%20bomber%20jacket%20spread%20on%20a%20dark%20charcoal%20concrete%20floor%2C%20dramatic%20top-down%20lighting%20creating%20bold%20contrast%20and%20deep%20shadows%2C%20editorial%20fashion%20photography%20with%20edgy%20urban%20industrial%20aesthetic&width=400&height=320&seq=hero-cat-jackets-v02&orientation=landscape"
                  alt="Jackets CSSBuy"
                  title="Jackets - CSSBuy Spreadsheet"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute bottom-3 left-3 text-sm font-semibold text-white bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                  Jackets
                </span>
              </a>
            </div>

            <a
              href="#categories"
              className="inline-flex items-center gap-1.5 mt-5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Ver todas as categorias
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}